module.exports = __webpack_public_path__ + "static/img/background.8584105e.svg";